module.exports = __webpack_public_path__ + "img/image_18.539beb8e.png";